/**
 * Smartfactor API
 * API for Smartfactor System
 *
 * The version of the OpenAPI document: 0.4.297
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ApplicationAppEntityTreeToRemoveRead } from './applicationAppEntityTreeToRemoveRead';
import { TreeRemovalReasonAppEntityTreeToRemoveRead } from './treeRemovalReasonAppEntityTreeToRemoveRead';
import { UserAppEntityTreeToRemoveRead } from './userAppEntityTreeToRemoveRead';


/**
 * 
 */
export interface TreeToRemoveAppEntityTreeToRemoveRead { 
    readonly id?: string;
    /**
     * Obręb
     */
    district?: string;
    /**
     * Arkusz mapy
     */
    mapSheet?: string;
    /**
     * Numer ewidencyjny
     */
    registryNumber?: string;
    /**
     * Gatunek
     */
    species?: string;
    /**
     * średnica na wysokości 130 cm
     */
    trunkCircumference130?: string;
    application?: ApplicationAppEntityTreeToRemoveRead;
    removalReasons?: Array<TreeRemovalReasonAppEntityTreeToRemoveRead>;
    /**
     * Typ obiektu (tree, shrub)
     */
    objectType?: TreeToRemoveAppEntityTreeToRemoveRead.ObjectTypeEnum;
    /**
     * Wysokość opłaty za usunięcie
     */
    removalFee?: string;
    /**
     * Inna przyczyna usunięcia
     */
    otherRemovalReason?: string;
    /**
     * Uzasadnienie usunięcia
     */
    removalJustification?: string;
    /**
     * Przeznaczenie terenu wycinki
     */
    landDesignation?: string;
    createdAt?: Date;
    updatedAt?: Date;
    deletedAt?: Date;
    createdBy?: UserAppEntityTreeToRemoveRead;
    updatedBy?: UserAppEntityTreeToRemoveRead;
}
export namespace TreeToRemoveAppEntityTreeToRemoveRead {
    export type ObjectTypeEnum = 'tree' | 'shrub';
    export const ObjectTypeEnum = {
        Tree: 'tree' as ObjectTypeEnum,
        Shrub: 'shrub' as ObjectTypeEnum
    };
}


